import Validation from '@core/logic/Validation'
import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import RecommendationBasis from '@company-common/model/kyc-form/RecommendationBasis'
import ClientDeclaration from '@company-common/model/kyc-form/ClientDeclaration'

export default class SharedRcmdBasisValidation extends Validation {
  validate (mainBasis: RecommendationBasis, dependantBasis: RecommendationBasis, clientDeclaration: ClientDeclaration, rcmd: BasicProduct[], belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, REQUIRE_NUMBER, REQUIRE_TRUE, WHEN } = this.validator()
    if (!rcmd.length) {
      return getMessages()
    }

    // ADD(WHEN(this.productDeviationReasonPreCondition(mainBasis, dependantBasis), REQUIRE(mainBasis.productDeviationsExistenceReason, 'Budget Deviation Existence Reason is required when recommended premium(s) is NOT in line with the client\'s budget.')), ['Basis of Recommendation'], ['productDeviationsExistenceReason'])
    ADD(REQUIRE(mainBasis.productRecommendationElaboration, 'Product Recommendation Elaboration is required to be filled.'), ['Basis of Recommendation'], ['productRecommendationElaboration'])
    ADD(REQUIRE(mainBasis.productRiskAndLimitationsElaboration, 'Product Risk and Limitations Elaboration is required to be filled.'), ['Basis of Recommendation'], ['productRiskAndLimitationsElaboration'])

    // Specify to JPara Changes
    // ADD(WHEN(!clientDeclaration.clientDecisionAgree, REQUIRE(mainBasis.recommendationDecision, 'Please provide the details that you want to specify')), ['Our Recommendation'])

    // Specify to JPara Changes
    ADD(WHEN(clientDeclaration.clientDisagreeDecision, REQUIRE(mainBasis.recommendationDecision, 'Please provide the details that you want to specify')), ['Client\'s Decision'], ['recommendationDecision'])

    // ADD(WHEN(this.riskConcentrationDeviationReasonPreCondition(mainBasis, dependantBasis), REQUIRE(mainBasis.riskConcentrationDeviationReason, 'Risk Concentration Deviation Reason is required when recommended premium(s) is NOT in line with the client\'s risk concentration.')), ['Basis of Recommendation'])
    // ADD(WHEN(this.riskToleranceDeviationReasonPreCondition(mainBasis, dependantBasis), REQUIRE(mainBasis.riskToleranceDeviationReason, 'Risk Tolerance Deviation Reason is required when recommended premium(s) is NOT in line with the client\'s risk tolerance.')), ['Basis of Recommendation'], ['riskToleranceDeviationReason'])
    // ADD(WHEN(this.timeHorizonDeviationReasonPreCondition(mainBasis, dependantBasis), REQUIRE(mainBasis.timeHorizonDeviationReason, 'Time Horizon Deviation reason is required when Time Horizon Protection is no.')), ['Basis of Recommendation'], ['timeHorizonDeviationReason'])

    return getMessages()
  }

  productDeviationReasonPreCondition (mainBasis: RecommendationBasis, dependantBasis: RecommendationBasis) {
    return mainBasis.productDeviationsExistence === 'yes' ||
            dependantBasis.productDeviationsExistence === 'yes'
  }

  // riskConcentrationDeviationReasonPreCondition (mainBasis: RecommendationBasis, dependantBasis: RecommendationBasis) {
  //   return mainBasis.riskConcentration === 'no' ||
  //           dependantBasis.riskConcentration === 'no'
  // }

  riskToleranceDeviationReasonPreCondition (mainBasis: RecommendationBasis, dependantBasis: RecommendationBasis) {
    return mainBasis.riskToleranceInTune === 'no' ||
            dependantBasis.riskToleranceInTune === 'no'
  }

  timeHorizonDeviationReasonPreCondition (mainBasis: RecommendationBasis, dependantBasis: RecommendationBasis) {
    return mainBasis.timeHorizonProtection === 'no' ||
            mainBasis.timeHorizonSavings === 'no' ||
            dependantBasis.timeHorizonProtection === 'no' ||
            dependantBasis.timeHorizonSavings === 'no'
  }
}
